import { ArticleSharp } from '@mui/icons-material';
import {
  GridActionsCellItem,
  GridColDef,
  GridColType,
  GridFilterOperator,
  GridValidRowModel,
  getGridSingleSelectOperators,
  getGridStringOperators,
} from '@mui/x-data-grid-pro';

export default function generateAuditLogColumns(
  handleDetailsClick: (gridRow: GridValidRowModel) => () => void,
  alias: (text: string) => string,
): GridColDef[] {
  const stringFilterOperator = {
    operators: getGridStringOperators().filter(
      (operator) => operator.value === 'equals',
    ),
  };

  const singleSelectFilterOperator = {
    operators: getGridSingleSelectOperators().filter(
      (operator: GridFilterOperator): boolean => operator.value === 'is',
    ),
  };

  const AuditLogsGridColumns: GridColDef[] = [];

  const emailColumn: GridColDef = {
    field: 'email',
    headerName: alias('email'),
    width: 200,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const userNameColumn: GridColDef = {
    field: 'username',
    headerName: alias('User Name'),
    width: 200,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const urlColumn: GridColDef = {
    field: 'url',
    headerName: alias('URL'),
    width: 200,
    flex: 1,
    filterOperators: stringFilterOperator.operators,
  };

  const httpMethodColumn: GridColDef = {
    field: 'httpMethod',
    headerName: alias('HTTP Method'),
    width: 200,
    flex: 1,
    type: 'singleSelect',
    valueOptions: ['PUT', 'POST', 'PATCH', 'DELETE'],
    filterOperators: singleSelectFilterOperator.operators,
  };

  const requestBodyColumn: GridColDef = {
    field: 'body',
    type: 'actions' as GridColType,
    headerName: alias('Details'),
    description: alias('Details'),
    width: 120,
    flex: 1,
    cellClassName: 'actions',
    getActions: ({ row }) => [
      // biome-ignore lint/correctness/useJsxKeyInIterable: noop
      <GridActionsCellItem
        icon={<ArticleSharp />}
        label={alias('Edit')}
        className='textPrimaryx'
        color='inherit'
        onClick={handleDetailsClick(row)}
      />,
    ],
  };

  AuditLogsGridColumns.push(
    userNameColumn,
    urlColumn,
    httpMethodColumn,
    emailColumn,
    requestBodyColumn,
  );

  return AuditLogsGridColumns;
}
